<template>
    <Dialog ref="dialog" :config="config" :beforeClose="beforeClose" :visible='visible' :cancelDialog="cancelDialog" :confirmDialog='confirmDialog' :isdeling='isdeling'>
        <p class="text">是否确定将 <span style="color: #4F71FF">{{rowData.nowCompany}}</span> 公司， 由账号 <span style="color: #4F71FF">{{rowData.remove}} </span>移交给账号 <span style="color: #4F71FF">{{rowData.receive}}</span>！</p>
        <p class="tips">注意：移交公司后，您将不能再查看该公司数据！</p>
    </Dialog>
</template>

<script>
import Dialog from "@/components/Dialog";
export default {
  props: {
    rowData:{
      type: Object,
    },
    visible: {
      type: Boolean,
    },
    isdeling: {
      type: Boolean,
    },
    cancelDialog:{
      type: Function,
      default: () => {},
    },
    confirmDialog:{
      type: Function,
      default: () => {},
    }
  },
  components: {
      Dialog,
  },
  data() {
    return {
      config: {
        top: '20vh',
        width: '24rem',
        title: '移交公司',
        center: true,
        btnTxt: ['确定','取消'],
      },
    };
  },
  methods: {
    beforeClose(){
      console.log('关闭前');
    },
  }
};
</script>

<style lang="less" scoped>
  .tips{
    color: #FF0000;
    font-size: 13px;
  }
  .margin{
      margin: 0 0 0 95px;;
  }
  .text{
    color: #333333;
    font-size: 14px;
    margin: 6px 0;
  }
</style>
